import React, { useCallback, useMemo } from "react";
import { DateTime } from "luxon";
import { DateRangeFilter, SingleDateFilter } from "../toolbar/DateRangeFilter";
import { RP } from "../../../pages/root/transaction/tabs/transfers/TransfersTable";

const MAX_DATE = DateTime.local();

export const getYesterdayDateTime = (): DateTime => {
  const date = new Date()
  date.setDate(date.getDate() - 1)

  return DateTime.fromJSDate(date)
}

export interface WithDate {
  date: string
}

export function RangeFilterComponent<T extends WithDate>(p: RP<T>) {
  // @ts-ignore
  const range: DateRange | undefined = p.columnDef.tableData.filterValue;
  const start = useMemo(() => range?.start || getYesterdayDateTime(), [range]),
    finish = useMemo( () => range?.finish || MAX_DATE, [range]);

  const onChange = useCallback( (start: DateTime, finish: DateTime) => {
    // @ts-ignore
    p.onFilterChanged(p.columnDef.tableData.id, {start, finish})
  }, [p])

  return <>
    <DateRangeFilter start={start} finish={finish} onChange={onChange} />
  </>
}

export function SingleDateFilterComponent<T extends WithDate>(p: RP<T>) {
  // @ts-ignore
  const range: DateRange | undefined = p.columnDef.tableData.filterValue;
  const start = useMemo(() => range?.start || getYesterdayDateTime(), [range]),
    finish = useMemo( () => range?.start || MAX_DATE, [range]);

  const onChange = useCallback( (start: DateTime, finish: DateTime) => {
    // @ts-ignore
    p.onFilterChanged(p.columnDef.tableData.id, {start, finish})
  }, [p])

  return <>
    <SingleDateFilter start={start} onChange={onChange} />
  </>
}
